import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PageContentService } from "../../../services/help/pagecontent.service";
import { DomSanitizer } from '@angular/platform-browser';
import { PageContent } from '@app/models/help/pagecontent.model';

@Component({
  selector: 'app-pagecontent',
  templateUrl: './pagecontent.component.html',
  styleUrls: ['./pagecontent.component.scss']
})
export class PageContentComponent implements OnInit {

  public pageContent: PageContent;

  constructor(private pageContentService: PageContentService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute) {
    this.pageContent = new PageContent();
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let id = params['id'];
      this.pageContentService.get(id).subscribe(result => {
        this.pageContent = <PageContent>result;
        this.pageContent.content = this.sanitizer.bypassSecurityTrustHtml(this.pageContent.content);
      });
    });
  }
} 
